<template>
  <div style="min-height: 100vh">
    <v-app-bar app color="primary" dark dense>
      <v-app-bar-nav-icon @click.stop="miniDrawer = !miniDrawer"/>
      <v-spacer></v-spacer>
      <v-btn icon @click="$router.push({ name: 'Notifications' })">
        <v-badge
            :content="user.notifications"
            :value="user.notifications || null"
            color="red"
            overlap
        >
          <v-icon>mdi-bell</v-icon>
        </v-badge>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer :mini-variant.sync="miniDrawer" permanent app>
      <!---<v-list-item class="px-2">
        <v-list-item-content>
          <img
            :src="require('@/assets/images/logo.jpg')"
            :height="miniDrawer ? 15 : 80"
          />
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    -->
      <v-list dense nav>
        <v-list-item
            v-for="item in items"
            :key="item.title"
            link
            :to="{ name: item.route }"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block @click="logout" color="primary" :width="40">
            <v-icon>mdi-logout</v-icon>
            <template v-if="!miniDrawer">Odjava</template>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <v-main class="app-background fill-height">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>
  </div>
</template>
<script>
export default {
  data: () => ({
    miniDrawer: false,
    items: [
      {
        title: "Podjetja",
        icon: "mdi-view-dashboard",
        route: "Companies",
      },
      {
        title: "Zaposleni",
        icon: "mdi-account-group",
        route: "Employees",
      },
      {
        title: "Vozila",
        icon: "mdi-car-estate",
        route: "Vehicles",
      },
      {
        title: "Administratorji",
        icon: "mdi-account-multiple",
        route: "Users",
      },
      {
        title: "Nastavitve",
        icon: "mdi-cog",
        route: "Settings",
      },
    ],
    right: null,
  }),
  computed: {
    user() {
      return this.$store.getters["user/user"] || {};
    },
  },
  mounted() {
  },
  methods: {
    logout() {
      this.$store
          .dispatch("user/logout")
          .then(() => {
            this.$router.push({name: "Home"});
          })
          .catch(() => {
            this.$router.push({name: "Home"});
          });
    },
  },
};
</script>
<style scoped>
.app-background {
  background: #eeeeee;
}
</style>
